import type { FilterKey } from '../../../Entities/Search/QueryParams.entity';

export const getRangeFilterPartnerId = (filterId: FilterKey) => {
  const nameParts = filterId.split('__');
  if (nameParts.length !== 2) return undefined;
  const partnerSuffix = nameParts[1] === 'gte' ? 'lte' : 'gte';
  return `${nameParts[0]}__${partnerSuffix}`;
};
